import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './InsightsPage.css';

const categories = [
  'AI and ML',
  'Article',
  'Case Study',
  'CDMP',
  'Conference',
  'DAMA Tunisia Updates',
  'Data Ethics',
  'Data Governance',
  'Data Management',
  'Data Maturity',
  'Data Modelling and Design',
  'Data Privacy',
  'Data Quality',
  'Data Storage and Operations',
  'Data Strategy',
  'Data Warehousing and Business Intelligence',
  'Learning and Development',
  'Member-only',
  'Mentoring',
  'Public',
  'Webinars',
  'Whitepaper',
];

const InsightsPage = () => {
  const [activeCategory, setActiveCategory] = useState(null);

  return (
    <div className="insights-page">
      <SharedNavbar />

      {/* ===== HERO ===== */}
      <section className="insights-hero">
        <div className="insights-hero-content">
          <h1>Insights</h1>
          <p>
            Access exclusive resources, expert articles, and tools to
            support your data management journey — explore,
            learn, and grow with DAMA Tunisia.
          </p>
        </div>
      </section>

      {/* ===== BODY ===== */}
      <section className="insights-body">
        <div className="insights-container">
          <div className="insights-layout">

            {/* ── SIDEBAR ── */}
            <aside className="insights-sidebar">
              <h2>Categories</h2>
              <ul>
                {categories.map((cat) => (
                  <li
                    key={cat}
                    className={activeCategory === cat ? 'active' : ''}
                    onClick={() => setActiveCategory(activeCategory === cat ? null : cat)}
                  >
                    {cat}
                  </li>
                ))}
              </ul>
            </aside>

            {/* ── CONTENU ── */}
            <div className="insights-main">

              {/* Info box */}
              <div className="insights-info-box">
                <p>
                  If you would like to filter by topic or public/member availability,
                  please select a category.
                </p>
                <p>
                  Please note that some resources are available to members only.
                  If you are interested in becoming a member of DAMA Tunisia,{' '}
                  <Link to="/membership" className="insights-link">
                    <strong>please visit this page</strong>
                  </Link>.
                </p>
              </div>

              {/* Catégorie sélectionnée */}
              {activeCategory && (
                <div className="insights-cat-msg">
                  <h3>Category: <span>{activeCategory}</span></h3>
                  <p>No insights available in this category yet. Check back soon!</p>
                  <button
                    onClick={() => setActiveCategory(null)}
                    className="insights-reset-btn"
                  >
                    ← View all categories
                  </button>
                </div>
              )}

              {/* Coming soon */}
              {!activeCategory && (
                <div className="insights-coming-soon">
                  <h3>Insights Coming Soon</h3>
                  <p>
                    Expert articles, case studies, whitepapers and webinar recordings
                    from DAMA Tunisia professionals will be available here soon.
                  </p>
                  <Link to="/membership" className="insights-join-btn">
                    Become a member to access exclusive resources
                  </Link>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

      {/* ===== CTA ===== */}
      <section className="insights-cta">
        <div className="insights-container">
          <div className="insights-cta-grid">
            <Link to="/membership" className="insights-cta-btn">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="insights-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/about" className="insights-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default InsightsPage;